import queryString from 'query-string';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME } from './packageName.constants.tsx';
import type { Page, Workflow } from './ApiQueryParams.types.tsx';
import { toApiUrlTransformer, fromUrlTransformer } from './toApiUrlTransformer.tsx';

export const getListWorkFlows = async (qs: string): Promise<Page<Workflow>> => {
	const filter = fromUrlTransformer(queryString.parse(qs));
	const query = queryString.stringify(toApiUrlTransformer(filter));

	try {
		return await performGetRequest(`/rest/api/3/workflow/search?${query}`);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getWorkflowsSearchAPI',
				packageName: PACKAGE_NAME,
				teamName: 'helix',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
